/* rhoneprints: every so often a glowing 1 or 0 drifts down in front of the page. click or tap it and it bursts into pixels. (tuned down: fewer on screen at once, spawns less often) */
/* rhoneprints: on mobile this whole poppable-number feature is skipped -- only the background falling-digits layer (rain.js) shows there. */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return;
  var COLS = ['#22e6ff', '#ff2fd0', '#f2efff', '#22e6ff', '#ff2fd0'];
  var live = 0;

  var st = document.createElement('style');
  st.textContent =
    '.gl-glow{position:fixed;top:0;z-index:9993;margin:0;padding:.8rem 1rem;border:0;background:none;font-family:"Space Mono",monospace;font-weight:700;line-height:1;cursor:pointer;touch-action:manipulation;color:var(--gl-c,#22e6ff);text-shadow:0 0 .6rem var(--gl-c,#22e6ff),0 0 1.6rem var(--gl-c,#22e6ff);animation:gl-glow-fall var(--gl-fall,10s) linear forwards,gl-glow-pulse 1.4s ease-in-out infinite alternate;-webkit-tap-highlight-color:transparent}' +
    '.gl-glow:hover{animation-play-state:paused}' +
    '@keyframes gl-glow-fall{from{transform:translateY(-6rem)}to{transform:translateY(calc(100vh + 4rem))}}' +
    '@keyframes gl-glow-pulse{from{filter:brightness(.9)}to{filter:brightness(1.4)}}' +
    '.gl-gbit{position:fixed;z-index:9993;pointer-events:none;will-change:transform,opacity}' +
    '.gl-tally{position:fixed;left:14px;bottom:58px;z-index:9999;padding:.6rem 1rem;font:inherit;font-size:1.2rem;letter-spacing:.14em;text-transform:lowercase;color:#f2efff;background:rgba(10,10,16,.85);border:1px solid rgba(34,230,255,.7);pointer-events:none;transition:opacity .4s}' +
    '.gl-tally.is-bump{animation:gl-tally-bump .4s steps(4)}' +
    '.gl-tally.is-done{border-color:#ffd23f;color:#ffd23f}' +
    '@keyframes gl-tally-bump{0%{transform:translate(-3px,0)}50%{transform:translate(3px,0);box-shadow:-2px 0 0 #22e6ff,2px 0 0 #ff2fd0}100%{transform:none}}' +
    '.gl-conf{position:fixed;top:0;z-index:10000;pointer-events:none;font-family:"Space Mono",monospace;font-weight:700;line-height:1;color:var(--gl-c,#22e6ff);text-shadow:0 0 .6rem var(--gl-c,#22e6ff);animation:gl-conf-fall var(--gl-d,4s) cubic-bezier(.3,.1,.6,.9) forwards;will-change:transform,opacity}' +
    '@keyframes gl-conf-fall{0%{transform:translateY(-12vh) rotate(0deg);opacity:1}85%{opacity:1}100%{transform:translateY(112vh) rotate(var(--gl-r,40deg));opacity:0}}' +
    '.gl-win{position:fixed;left:50%;top:22%;z-index:10001;transform:translateX(-50%);padding:1.2rem 2rem;font:inherit;font-size:1.8rem;letter-spacing:.14em;text-transform:lowercase;text-align:center;color:#f2efff;background:rgba(10,10,16,.94);border:1px solid #ffd23f;box-shadow:0 0 2.4rem rgba(255,210,63,.3);pointer-events:none;animation:gl-win 4.2s ease forwards}' +
    '@keyframes gl-win{0%{opacity:0;transform:translate(-50%,1rem)}10%,80%{opacity:1;transform:translate(-50%,0)}100%{opacity:0;transform:translate(-50%,-.6rem)}}' +
    '@media (max-width:749px){.gl-glow{padding:1.8rem 2rem}.gl-tally{bottom:14px}.gl-win{width:78vw;box-sizing:border-box}}';
  document.head.appendChild(st);

  function rnd(a, b) { return a + Math.random() * (b - a); }

  function burst(el, col) {
    var r = el.getBoundingClientRect();
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    if (window.glSfx && window.glSfx.crumble) window.glSfx.crumble();
    if (!el.animate) return;
    var size = 4, n = 42, frag = document.createDocumentFragment(), bits = [];
    var palette = [col, col, '#f2efff', '#ffffff'];
    for (var i = 0; i < n; i++) {
      var b = document.createElement('i');
      b.className = 'gl-gbit';
      var c = palette[Math.floor(Math.random() * palette.length)];
      b.style.cssText = 'left:' + (cx + rnd(-r.width * 0.3, r.width * 0.3)) + 'px;top:' + (cy + rnd(-r.height * 0.3, r.height * 0.3)) + 'px;width:' + size + 'px;height:' + size + 'px;background:' + c + ';box-shadow:0 0 6px ' + col;
      frag.appendChild(b);
      var ang = Math.random() * Math.PI * 2, d = rnd(30, 110);
      b.animate([
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + Math.cos(ang) * d + 'px,' + (Math.sin(ang) * d + rnd(0, 30)) + 'px) rotate(' + rnd(-240, 240) + 'deg)', opacity: 0 }
      ], { duration: rnd(500, 900), easing: 'cubic-bezier(.15,.7,.3,1)', fill: 'both' });
      bits.push(b);
    }
    document.body.appendChild(frag);
    setTimeout(function () { bits.forEach(function (b) { if (b.parentNode) b.parentNode.removeChild(b); }); }, 1100);
  }

  /* ---------- tally: how many glowing numbers have been popped (kept across visits, starts over after every celebration) ---------- */
  var GOAL = 10, KEY = 'gl-pops';
  var count = 0, celebrating = false;
  try {
    count = parseInt(localStorage.getItem(KEY) || '0', 10) || 0;
    if (count >= GOAL) count = 0;
    localStorage.removeItem('gl-pops-done');
  } catch (e) {}
  var tally = null;
  function paintTally(bump) {
    if (count < 1) return;
    if (!tally) {
      tally = document.createElement('div');
      tally.className = 'gl-tally';
      tally.setAttribute('data-gl-skip', '');
      tally.setAttribute('role', 'status');
      document.body.appendChild(tally);
    }
    tally.textContent = 'numbers popped ' + count + '/' + GOAL;
    tally.classList.toggle('is-done', count >= GOAL);
    if (bump) { tally.classList.remove('is-bump'); void tally.offsetWidth; tally.classList.add('is-bump'); }
  }
  function celebrate() {
    var win = document.createElement('div');
    win.className = 'gl-win';
    win.setAttribute('data-gl-skip', '');
    win.textContent = 'Congratz!';
    document.body.appendChild(win);
    setTimeout(function () { if (win.parentNode) win.parentNode.removeChild(win); }, 4400);
    if (window.glSfx && window.glSfx.kaching) window.glSfx.kaching();
    var palette = ['#22e6ff', '#ff2fd0', '#f2efff', '#22e6ff', '#ff2fd0', '#ffd23f'];
    var vw = window.innerWidth, total = vw < 750 ? 70 : 130;
    for (var i = 0; i < total; i++) {
      (function () {
        setTimeout(function () {
          var d = document.createElement('span');
          d.className = 'gl-conf';
          d.setAttribute('aria-hidden', 'true');
          d.textContent = Math.random() < 0.5 ? '0' : '1';
          d.style.left = rnd(0, vw - 20) + 'px';
          d.style.fontSize = rnd(16, 52) + 'px';
          d.style.setProperty('--gl-c', palette[Math.floor(Math.random() * palette.length)]);
          d.style.setProperty('--gl-d', rnd(3, 6) + 's');
          d.style.setProperty('--gl-r', rnd(-70, 70) + 'deg');
          d.addEventListener('animationend', function () { if (d.parentNode) d.parentNode.removeChild(d); });
          document.body.appendChild(d);
        }, rnd(0, 3200));
      })();
    }
  }
  function resetTally() {
    count = 0;
    celebrating = false;
    try { localStorage.setItem(KEY, '0'); } catch (e) {}
    if (tally && tally.parentNode) tally.parentNode.removeChild(tally);
    tally = null;
  }
  function popped() {
    if (celebrating) return;
    count = Math.min(GOAL, count + 1);
    try { localStorage.setItem(KEY, String(count)); } catch (e) {}
    paintTally(true);
    if (count >= GOAL) {
      celebrating = true;
      setTimeout(celebrate, 500);
      /* after the celebration the tally starts over, ready for the next round */
      setTimeout(resetTally, 7800);
    }
  }
  if (document.body) paintTally(false); else document.addEventListener('DOMContentLoaded', function () { paintTally(false); });
  window.__glPopped = function () { return count; };

  function spawn() {
    if (document.hidden || !document.body || live >= 2) return;
    var col = COLS[Math.floor(Math.random() * COLS.length)];
    var el = document.createElement('button');
    el.type = 'button';
    el.className = 'gl-glow';
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('tabindex', '-1');
    el.setAttribute('data-gl-skip', '');
    el.textContent = Math.random() < 0.5 ? '0' : '1';
    var vw = window.innerWidth, wide = vw >= 750;
    var minL = wide ? 340 : 10, maxL = Math.max(minL + 10, vw - 70);
    el.style.left = rnd(minL, maxL) + 'px';
    el.style.fontSize = rnd(wide ? 22 : 28, wide ? 46 : 52) + 'px';
    el.style.setProperty('--gl-c', col);
    el.style.setProperty('--gl-fall', rnd(8, 13) + 's');
    live++;
    var done = false;
    var gone = function () { if (done) return; done = true; live--; if (el.parentNode) el.parentNode.removeChild(el); };
    var flip = setInterval(function () { el.textContent = el.textContent === '0' ? '1' : '0'; }, rnd(600, 1200));
    el.addEventListener('animationend', function (e) { if (e.animationName === 'gl-glow-fall') { clearInterval(flip); gone(); } });
    /* pop on the touch itself (pointerdown), so a moving number is easy to catch on a phone; click still works as a fallback */
    var pop = function (e) {
      e.preventDefault(); e.stopPropagation();
      if (done) return;
      if (e.type === 'pointerdown') {
        /* the follow-up click would land on whatever is underneath: swallow it */
        var blk = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
        document.addEventListener('click', blk, true);
        setTimeout(function () { document.removeEventListener('click', blk, true); }, 450);
      }
      clearInterval(flip);
      burst(el, col);
      gone();
      popped();
    };
    el.addEventListener('pointerdown', pop);
    el.addEventListener('click', pop);
    document.body.appendChild(el);
  }

  /* a bit less often now: one every 6 to 12 seconds, never more than two on screen */
  function loop(first) {
    setTimeout(function () { spawn(); loop(false); }, first ? 4000 : rnd(6000, 12000));
  }
  loop(true);
  window.__glGlow = spawn;
})();